import electronBridge from '../utils/electronBridge';

export default function Chat() {
    let chatURL = process.env.PUBLIC_URL + "/llm-chat.html";
    
    // // Different implementation for Electron to prevent multiple instances
    // if (electronBridge.isElectron) {
    //     return (
    //         <iframe 
    //             src={chatURL + "?electron=1"} 
    //             className="w-full h-full border-0"
    //             sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-modals"
    //             title="Chat Interface"
    //         />
    //     );
    // }
    
    // Browser implementation (keep as is - it's working)
    return (
        <iframe 
            src={chatURL} 
            className="w-full h-full"
            data-supademo-ignore="true"
            data-no-track="true"
            sandbox="allow-scripts allow-same-origin allow-forms"
        />
    );
}